"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var DEFAULT_PROPS = {
    fps: 60,
    speed: 60,
    style: {},
    className: '',
    reverse: false,
    mode: 'vertical',
};
var SeamlessRoll = /** @class */ (function (_super) {
    __extends(SeamlessRoll, _super);
    function SeamlessRoll() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.containerDom = null;
        _this.wrapperDom = null;
        _this.sliderDom = null;
        _this.sliderDomCopy = null;
        _this.requestID = 0;
        _this.state = {
            step: 1,
            sliderSize: 0,
            containerSize: 0,
        };
        _this.init = function () {
            var _a = _this.props, _b = _a.speed, speed = _b === void 0 ? DEFAULT_PROPS.speed : _b, _c = _a.mode, mode = _c === void 0 ? DEFAULT_PROPS.mode : _c;
            var step = parseFloat((speed / DEFAULT_PROPS.fps).toFixed(2));
            var sliderSize = mode === 'vertical' ? _this.sliderDom.offsetHeight : _this.sliderDom.offsetWidth;
            var containerSize = mode === 'vertical' ? _this.containerDom.clientHeight : _this.containerDom.clientWidth;
            _this.setState({ step: step, sliderSize: sliderSize, containerSize: containerSize }, function () {
                cancelAnimationFrame(_this.requestID);
                if (sliderSize > containerSize) {
                    _this.sliderDomCopy.innerHTML = _this.sliderDom.innerHTML;
                    _this.requestID = requestAnimationFrame(_this.marquee);
                    _this.containerDom.onmouseover = function () {
                        cancelAnimationFrame(_this.requestID);
                    };
                    _this.containerDom.onmouseout = function () {
                        cancelAnimationFrame(_this.requestID);
                        _this.requestID = requestAnimationFrame(_this.marquee);
                    };
                }
                else {
                    _this.sliderDomCopy.innerHTML = '';
                    _this.containerDom.onmouseover = null;
                    _this.containerDom.onmouseout = null;
                }
            });
        };
        /**marquee */
        _this.marquee = function () {
            var _a = _this.state, sliderSize = _a.sliderSize, step = _a.step;
            var _b = _this.props, _c = _b.reverse, reverse = _c === void 0 ? DEFAULT_PROPS.reverse : _c, _d = _b.mode, mode = _d === void 0 ? DEFAULT_PROPS.mode : _d;
            var key = mode === 'vertical' ? 'top' : 'left';
            var position = parseFloat(_this.getStyle(_this.wrapperDom, key));
            if (reverse) {
                if (position >= 0) {
                    _this.wrapperDom.style[key] = "-" + sliderSize + "px";
                }
                else {
                    _this.wrapperDom.style[key] = position + step + "px";
                }
            }
            else {
                if (sliderSize - Math.abs(position) <= 0) {
                    _this.wrapperDom.style[key] = '0px';
                }
                else {
                    _this.wrapperDom.style[key] = position - step + "px";
                }
            }
            cancelAnimationFrame(_this.requestID);
            _this.requestID = requestAnimationFrame(_this.marquee);
        };
        _this.getStyle = function (ele, attr) {
            if (window.getComputedStyle) {
                return window.getComputedStyle(ele)[attr];
            }
            return ele.currentStyle[attr];
        };
        return _this;
    }
    SeamlessRoll.prototype.componentDidMount = function () {
        this.init();
    };
    SeamlessRoll.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _a = this.props, children = _a.children, speed = _a.speed, style = _a.style, className = _a.className, mode = _a.mode;
        if (children !== prevProps.children || speed !== prevProps.speed || style !== prevProps.style || className !== prevProps.className || mode !== prevProps.mode) {
            this.init();
        }
    };
    SeamlessRoll.prototype.componentWillUnmount = function () {
        cancelAnimationFrame(this.requestID);
    };
    // 检测dom宽高变更
    // checkResize = () => {
    SeamlessRoll.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, _b = _a.style, style = _b === void 0 ? DEFAULT_PROPS.style : _b, _c = _a.className, className = _c === void 0 ? DEFAULT_PROPS.className : _c, _d = _a.mode, mode = _d === void 0 ? DEFAULT_PROPS.mode : _d;
        var containerStyle = {
            position: 'relative',
            overflow: 'hidden',
            width: '100%',
            height: '100%',
        };
        var WrapperStyle = {
            position: 'absolute',
            top: 0,
            left: 0,
            right: mode === 'vertical' ? 0 : 'auto',
            bottom: mode === 'vertical' ? 'auto' : 0,
            whiteSpace: mode === 'vertical' ? 'normal' : 'nowrap',
        };
        var sliderStyle = {
            display: mode === 'vertical' ? 'block' : 'inline-block',
        };
        return (react_1.default.createElement("div", { className: className, ref: function (dom) { return (_this.containerDom = dom); }, style: __assign(__assign({}, containerStyle), style) },
            react_1.default.createElement("div", { ref: function (dom) { return (_this.wrapperDom = dom); }, style: WrapperStyle },
                react_1.default.createElement("div", { style: sliderStyle, ref: function (dom) { return (_this.sliderDom = dom); } }, children),
                react_1.default.createElement("div", { style: sliderStyle, ref: function (dom) { return (_this.sliderDomCopy = dom); } }))));
    };
    return SeamlessRoll;
}(react_1.default.PureComponent));
exports.default = SeamlessRoll;
